import React from 'react';

import { NavLink } from 'react-router-dom';

const year = new Date().getFullYear();

const Footer: React.FC = () => {
	return (
		<footer className="site-footer">
			<div className="site-footer-top">
				<div className="container">
					<nav aria-label="External project links">
						<ul>
							<li>
								<a href="https://www.lapoflove.com/pet-loss-support-resources" target="_blank" rel="noopener noreferrer">
									Pet Loss and Grief Resources
								</a>
							</li>
							<li>
								<a href="https://info.lapoflove.com/keepsakes" target="_blank" rel="noopener noreferrer">
									Explore Pet Memorial Keepsakes
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
			<div className="site-footer-bottom">
				<div className="container">
					<nav aria-label="Site navigation">
						<ul className="menu-component">
							<li className="menu-component__item">
								<NavLink to="/using-vetangel" target="_blank">
									Using VetAngel
								</NavLink>
							</li>
							<li className="menu-component__item">
								<NavLink to="/disclaimer" target="_blank">
									DISCLAIMER
								</NavLink>
							</li>
							<li className="menu-component__item">
								<NavLink to="/privacy-policy" target="_blank">
									Privacy Policy
								</NavLink>
							</li>
							<li className="menu-component__item">
								<NavLink to="/terms-and-conditions" target="_blank">
									Terms and Conditions
								</NavLink>
							</li>
							<li className="menu-component__item">
								<NavLink to="/accessibility" target="_blank">
									Accessibility Policy
								</NavLink>
							</li>
						</ul>
					</nav>
					<p className="site-footer-bottom__copyright">© {year} VetAngel. All rights reserved.</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
